import styled from "styled-components";

export const StyledIcon = styled.div`
    text-transform: none;
    font-weight: 400;
`;

export const Container = styled.div`
  margin-bottom: 32px;
`;
